import { Area, Asset } from ".";
import { ContractAssetAPI } from "../api";
export class ContractAsset {
  constructor(props) {
    this.id = props.objectId || "";
    this.contractId = props.contract?.objectId || "";
    this.assetId = props.asset?.objectId || "";
    this.areaId = props.area?.objectId || "";
    this.images = props.images.map(i => i);
    this.cost = props.cost || 0;
    this.note = props.note || "";
  }
  static async getContractAsset(payload) {
    const { data } = await ContractAssetAPI.getContractAsset(payload);
    const classesData = new ContractAsset(data.result);
    return classesData;
  }
  static async getContractAssetsByContract(payload) {
    const { data } = await ContractAssetAPI.getContractAssetsByContract(
      payload
    );
    const areas = [];
    // group by area
    data.result.forEach(item => {
      const area = areas.find(a => a?.area?.objectId === item?.area?.objectId);
      if (area) {
        area.assets.push(item);
      } else {
        areas.push({
          area: item.area,
          assets: [item],
          isShow: false
        });
      }
    });
    return areas;
  }
  static async updateContractAsset(payload) {
    const { data } = await ContractAssetAPI.updateContractAsset(payload);
    const classesData = new ContractAsset(data.result);
    return classesData;
  }
  static async removeContractAsset(payload) {
    const { data } = await ContractAssetAPI.removeContractAsset(payload);
    const classesData = new ContractAsset(data.result);
    return classesData;
  }
  static async createContractAsset(payload) {
    const { data } = await ContractAssetAPI.createContractAsset(payload);
    const classesData = new ContractAsset(data.result);
    return classesData;
  }
}
